<template>
  <div class="hello">
    <div>
      <div class="line">
        <img :src="json.roseUrl" class="img_avater" />
        <div>
          <div class="col">
            <b>{{ json.roseName }}</b>
          </div>
          <div class="col_2">
            <b>{{ json.createTime }}</b>
          </div>
        </div>
      </div>
    </div>

    <div class="p_content">
      <p>{{ json.content }}</p>
    </div>

    <div v-for="(item, index) in json.imageList" :key="key">
      <div v-if="json.imageList.length === 1">
        <img :src="item" class="img_1" />
      </div>
      <div v-else-if="json.imageList.length === 2">
        <img :src="item" class="img_2" />
      </div>
      <div v-else>
        <img :src="item" class="img_3" />
      </div>
    </div>
  </div>
</template>

<script>
import http from "../utils/http";
import qs from "qs";

export default {
  name: "CircleDetail",
  data() {
    return {
      dynamicId: "",
      uid: "",
      json: {
        content: "你好",
        dyType: 0,
        commentCnt: 1,
        goodCnt: 1,
        roseUrl:
          "https://ss3.baidu.com/-fo3dSag_xI4khGko9WTAnF6hhy/baike/pic/item/54fbb2fb43166d2249a0126c462309f79152d276.jpg",
        roseName: "陆逊",
        hasGood: false,
        createTimestamp: 0,
        createTime: "",
        imageList: []
      }
    };
  },
  methods: {
    getList(dynamicId, uid) {
      http
        .post("/api/e-circle/group/dynamicInfo", {
          dynamicId: dynamicId,
          uid: uid
        })
        .then(res => {
          // todo 需要修改为正确的解析
          this.json = res.data.result;
          this.imgSize = this.json.imageList.length;
        })
        .catch(error => console.log(error));
    },
    getData(params) {
      //params: 原生调用Vue时传值（params）给Vue
      console.log("得到原生传值结果:" + params);
      alert(JSON.stringify(params));
    }
  },
  created() {},
  mounted() {
    this.dynamicId = this.$route.query.dynamicId;
    this.uid = this.$route.query.uid;
    console.log(this.dynamicId);
    this.getList(this.dynamicId, this.uid);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: bold;
  font-size: 26px;
}
ol {
  margin-left: 20px;
  padding: 10px;
}
li {
  margin-top: 10px;
}
ul {
  list-style-type: none;
  padding: 0;
}

a {
  color: #42b983;
}
p {
  color: #000;
  font-size: 26px;
  text-align: left;
  width: 100%;
  letter-spacing: 4px;
  line-height: 200%;
}
.hello {
  margin-left: 20px;
  margin-right: 20px;
  padding-right: 10px;
  /* width: 100%; */
}
.line {
  display: flex;
  flex-wrap: wrap;
}
.col {
  display: flex;
  flex-wrap: wrap;
  margin-left: 20px;
}
.col_2 {
  flex-wrap: wrap;
  display: flex;
  margin-top: 10px;
  margin-left: 20px;
}
.p_content {
  width: 100%;
  display: inline-flex;
  flex: 1;
  text-align: left;
  float: left;
}
.img_avater {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
.img_1 {
  flex: 1;
  padding: 8px;
  float: left;
  width: 100%;
  height: 376px;
}
.img_2 {
  flex: 1;
  padding: 8px;
  float: left;
  width: 45%;
  height: 30vw;
}

.img_3 {
  flex: 1;
  padding: 8px;
  float: left;
  height: 30vw;
  width: 30%;
}

b {
  text-align: left;
  font-size: 26px;
  margin-top: 10px;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/CircleDetail.vue